module.exports = __webpack_public_path__ + "img/search-d.bbeff59d.png";